import React from "react";
import { Nav, Button } from "react-bootstrap";
const SignedOutLinks = () => {
  return (
    <div className="auth-buttons">
      <Nav>
        <Nav.Link href="/signup">
          <Button variant="light" className="signup-btn">
            Sign Up
          </Button>
        </Nav.Link>
        <Nav.Link href="/signin">
          <Button variant="outline-dark" className="login-btn">
            Login
          </Button>
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default SignedOutLinks;
